<template lang="pug">
.ride-experience-card
  .ride-top
    .ride-title 单车骑行月卡
    .ride-go-mycard(@click="goMycard")
      div 查看已有骑行卡
      img(src="https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png?x-oss-process=image/format,webp")
  .ride-bottom
    .ride-btn(@click="openModal" :style="rideTrialUpgradeAB !=='Y'?'width:1.07rem':''")
      .ride-img
        img(src="https://m.hellobike.com/resource/gallery/61/age-Of6N7D.png?x-oss-process=image/quality,q_80")
      span {{rideTrialUpgradeAB==='Y'?'升级正式版享':'续正式版享'}}
</template>
<script>
import { env } from '@hb/hbridge';
import config from '@/const/config';
import {
  getNoScroll,
} from '@/utils';

export default {
  props: {
    rideTrialUpgradeAB: {
      type: String,
      default: 'N',
    },
  },
  methods: {
    goMycard() {
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/moped/business/htr_my_card_page';
      } else {
        window.location.href = `https://m.hellobike.com/AppHelloBikeMainH5/${config.env !== 'pro' ? `${config.env}/` : ''
          }latest/index.html#/my-cards?adsource=`;
      }
    },
    openModal() {
      getNoScroll(true);
      this.$emit('openModal');
    },
  },
};
</script>
<style lang="less" scoped>
.ride-experience-card {
  margin: 0.1rem;
  background: #fff;
  border-radius: 0.16rem;
  height: 1.31rem;

  .ride-top {
    display: flex;
    justify-content: space-between;
    padding-top: 0.12rem;
    margin: 0 0.12rem 0 0.15rem;

    .ride-title {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 600;
      line-height: 0.22rem;
    }

    .ride-go-mycard {
      color: #5a6066;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.13rem;
      font-style: normal;
      font-weight: 400;
      display: flex;

      img {
        margin-top: 0.03rem;
        width: 0.12rem;
        height: 0.12rem;
      }
    }
  }

  .ride-bottom {
    width: 3.21rem;
    height: 0.72rem;
    background-image: url(https://m.hellobike.com/resource/gallery/61/-iGbOZFw_Group%201707482857.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    margin: 0.1rem auto 0 auto;
    position: relative;

    .ride-btn {
      position: absolute;
      width: 1.17rem;
      min-width: 1.07rem;
      height: 0.26rem;
      top: 0.23rem;
      right: 0.14rem;
      border: 0.01rem solid #fff;
      background: #d2e4fb;
      text-align: left;
      border-radius: 0.5rem;
      padding-top: 0.04rem;
      padding-left: 0.11rem;
      font-size: 0.13rem;
      display: flex;

      .ride-img {
        padding-top: 0.02rem;

        img {
          width: 0.14rem;
          height: 0.14rem;
          margin-right: 0.04rem;
        }
      }

    }
  }
}
</style>
